import { render, staticRenderFns } from "./PasswordResetConfirm.vue?vue&type=template&id=498a828e"
import script from "./PasswordResetConfirm.vue?vue&type=script&lang=js"
export * from "./PasswordResetConfirm.vue?vue&type=script&lang=js"
import style0 from "./PasswordResetConfirm.vue?vue&type=style&index=0&id=498a828e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports